/**
 * Created by noOne on 28/02/2018.
 */
"use strict";

export default class TutorialPopup extends PIXI.Container {
    constructor() {
        super();

        this._bg = null;
        this._textView = null;

        this.init();
    }

    init() {

        this._bg = P3.createSprite("popup_panel", this, new PIXI.Point(0.5, 0.5));
        //  this._bg.tint = 0xd3d3d3;
        //  this._bg.width = 350;
        // this._bg.height = 175;

        this._textView = createText("", {
            size: 32,
            fill: 0xfefcef,
            align: "center",
            wordWrap: true,
            wordWrapWidth: this._bg.width - 175
        }, "Ed Gothic");
        this._textView.anchor.set(0.5);
        this._textView.y = 25;
        this.addChild(this._textView);

        this.scale.set(0);
    }

    show(copy) {
        this.scale.set(0);
        this._textView.text = copy;
        TweenMax.to(this.scale, 0.3, {x: 1, y: 1, ease: Back.easeOut});
    }

    hide() {
        this.scale.set(1);
        this._textView.text = "";
        TweenMax.to(this.scale, 0.3, {x: 0, y: 0, ease: Back.easeIn});
    }
}